import { getDateWithYear, untilDate } from '../shared/date';
import { formatPrice } from '../shared/currency';
import { parseSolutionFromCreative } from '../shared/ad-helpers';
import * as plans from '../shared/subscription-plans';

const subscriptionNameMapping = {
    [plans.MK_TWENTY_FOUR_WEEKS_8999_TWENTY_FOUR_WEEKS_4999_INTRO_PLAN]: '24-Week Premium Plan',
    [plans.MK_TWENTY_FOUR_WEEKS_8999_WITHOUT_TRIAL_PLAN]: '24-Week Premium Plan',
    [plans.MK_TWELVE_WEEKS_5999_TWELVE_WEEKS_3499_INTRO_PLAN]: '12-Week Premium Plan',
    [plans.MK_TWELVE_WEEKS_5999_WITHOUT_TRIAL_PLAN]: '12-Week Premium Plan',
    [plans.MK_FOUR_WEEKS_2999_FOUR_WEEKS_1999_INTRO_PLAN]: '4-Week Premium Plan',
    [plans.MK_FOUR_WEEKS_2999_WITHOUT_TRIAL_PLAN]: '4-Week Premium Plan',
    [plans.MK_FOUR_WEEKS_2999_ONE_WEEK_899_TRIAL_PLAN]: '1-Week Trial'
};

const getSubscriptionName = plan => subscriptionNameMapping[plan];

const getBillingPeriodLabel = ({ unit, value }) => {
    if (unit === 'week') {
        if (value === 1) {
            return 'Weekly';
        }

        return `Every ${value} weeks`;
    }

    if (unit === 'month') {
        if (value === 1) {
            return 'Monthly';
        }

        return `Every ${value} month`;
    }

    return `Every ${value} ${unit}`;
};

const subscriptionMapper = {
    toDomain(subscriptionData) {
        return {
            price: formatPrice(subscriptionData.price, subscriptionData.plan?.currency),
            name: getSubscriptionName(subscriptionData.plan?.plan),
            plan: subscriptionData.plan,
            id: subscriptionData.id,
            hasTrial: subscriptionData.hasTrial,
            billingPeriodLabel: getBillingPeriodLabel(subscriptionData.plan?.billingPeriod),
            trial: subscriptionData.plan?.trial ? { ...subscriptionData.plan.trial, price: formatPrice(subscriptionData.plan.trial.price, subscriptionData.plan?.currency) } : null,
            status: subscriptionData.status,
            nextChargeDate: subscriptionData.nextChargeAt ? getDateWithYear(subscriptionData.nextChargeAt) : null,
            createdAtDate: getDateWithYear(subscriptionData.createdAt),
            validUntilDate: getDateWithYear(subscriptionData.validUntil),
            isActive: untilDate(subscriptionData.validUntil).isValid,
            solution: parseSolutionFromCreative(subscriptionData.creative),
            features: subscriptionData.plan?.features || []
        };
    }
};

const statusSubscriptionMapper = {
    toDomain(subscriptionData) {
        return {
            price: formatPrice(subscriptionData.price, subscriptionData.currency),
            name: getSubscriptionName(subscriptionData.plan),
            billingPeriod: subscriptionData.billingPeriod,
            plan: subscriptionData.plan,
            id: subscriptionData.id,
            trial: subscriptionData.trial ? { ...subscriptionData.trial, price: formatPrice(subscriptionData.trial.price, subscriptionData.currency) } : null
        };
    }
};

export {
    subscriptionMapper,
    statusSubscriptionMapper,
    getSubscriptionName
};
